import { FC } from 'react';
import { Col, Row } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { FullHeightFlexColumn } from '@/shared';

import Sider from './layout/01-Sider';
import Content from './layout/02-Content';
import Metadata from './meta';

const Settings: FC = (): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <FullHeightFlexColumn>
            <Metadata />
            <style>
                {`
                    .settings-search-target-highlight {
                        background: ${token.colorInfoBg};
                        border-radius: ${token.borderRadius}px;
                        box-shadow: 0 0 0 2px ${token.colorPrimaryBorder};
                        transition: background 0.2s ease, box-shadow 0.2s ease;
                    }
                `}
            </style>
            <Row style={{ flex: '1 1 0%', minHeight: 0 }} wrap={false}>
                <Col span={4}>
                    <Sider />
                </Col>
                <Col flex='auto' style={{ minHeight: 0, padding: '1.5rem 0', overflow: 'auto' }}>
                    <Content />
                </Col>
            </Row>
        </FullHeightFlexColumn>
    );
};

export default Settings;
